import { Outlet } from "react-router-dom";

// Page shell. Header has the nofuzz wordmark + a sign-out stub button (no-op until
// chunks 2/3 wire auth). Footer carries legal-entity attribution + version tag.
export default function Layout() {
  const handleSignOutStub = () => {
    // Chunk 2/3 will wire this to clear the auth session + redirect to /.
    // For now it's intentionally a no-op so the button has a stable target.
  };

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="container layout-header-inner">
          <span className="wordmark">
            nofuzz
            <svg
              className="ball"
              viewBox="0 0 100 100"
              role="img"
              aria-label="tennis ball"
              focusable="false"
            >
              <circle cx="50" cy="50" r="46" fill="#d3eb45" stroke="#a8c63a" strokeWidth="2" />
              <path d="M 6 32 Q 50 64 94 32" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" />
              <path d="M 6 68 Q 50 36 94 68" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" />
            </svg>
          </span>
          <button
            type="button"
            className="button button-ghost"
            onClick={handleSignOutStub}
            aria-label="Sign out (not yet wired)"
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="layout-main">
        <div className="container">
          <Outlet />
        </div>
      </main>
      <footer className="layout-footer">
        <div className="container">
          <small>© Capital Thought, LLC · v0.1 alpha</small>
        </div>
      </footer>
    </div>
  );
}
